import ReducerRegistry from '../base/redux/ReducerRegistry';
import { RESET_SHARED_BROWSER_STATE, SET_SHARED_BROWSER_STATE } from './actionTypes';
const DEFAULT_STATE = {
    isOpen: false,
    navigationVersion: 0,
    history: [],
    currentIndex: -1
};
ReducerRegistry.register('features/shared-browser', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SHARED_BROWSER_STATE: {
            return {
                ...state,
                isOpen: action.isOpen !== undefined ? action.isOpen : state.isOpen,
                sessionId: action.sessionId || state.sessionId,
                ownerId: action.ownerId || state.ownerId,
                url: action.url !== undefined ? action.url : state.url,
                navigationVersion: action.navigationVersion !== undefined ? action.navigationVersion : state.navigationVersion,
                history: action.history !== undefined ? action.history : state.history,
                currentIndex: action.currentIndex !== undefined ? action.currentIndex : state.currentIndex,
                scrollX: action.scrollX !== undefined ? action.scrollX : state.scrollX,
                scrollY: action.scrollY !== undefined ? action.scrollY : state.scrollY
            };
        }
        case RESET_SHARED_BROWSER_STATE:
            return DEFAULT_STATE;
        default:
            return state;
    }
});
